export default {
  cursor: false,
  current_index: 0,
  journal_article_index: 0,
  landing_scroll_percent: 0,
  landing_content_overlay: false,
}
